import { useEffect, useState } from 'react';
import { usePathname } from 'next/navigation';
import { PrismicNextLink } from '@prismicio/next';

type SectionIdentifierNavigationItemProps = {
  id: string;
  title: string;
  label: string;
};

export const SectionIdentifierNavigationItem = ({
  id,
  title,
  label,
}: SectionIdentifierNavigationItemProps) => {
  const pathname = usePathname();

  const [elementExists, setElementExists] = useState<boolean>(false);

  useEffect(() => {
    const element = document.getElementById(id);

    setElementExists(element !== null);
  }, [pathname]);

  if (!elementExists) {
    return null;
  }

  return (
    <PrismicNextLink href={id} title={title} className="site-head__link">
      {label}
    </PrismicNextLink>
  );
};
